import { useDispatch, useSelector } from 'react-redux';
import { FiMoon, FiSun } from 'react-icons/fi';
import { setDarkMode } from '../../reducers/darkSlice';
import { updateCurrentUserTheme } from '../../utils/userSessionApi';
import { AppTooltip } from '../ui/AppTooltip';

export const ThemeToggle = ({ label, persist = false }) => {
  const dispatch = useDispatch();
  const isDarkMode = useSelector((state) => state.darkMode.isDarkMode);

  const toggleTheme = () => {
    const nextIsDark = !isDarkMode;
    dispatch(setDarkMode(nextIsDark));
    if (persist) {
      updateCurrentUserTheme(nextIsDark ? 'dark' : 'light').catch(() => {});
    }
  };

  return (
    <AppTooltip label={label} placement='bottom'><button
      type='button'
      onClick={toggleTheme}
      className='inline-flex h-10 w-10 items-center justify-center rounded-[var(--radius-md)] border border-[var(--border-subtle)] bg-[var(--surface-panel)] text-[var(--text-secondary)] hover:bg-[var(--surface-panel-muted)]'
      aria-label={label}
    >
      {isDarkMode ? <FiSun aria-hidden='true' /> : <FiMoon aria-hidden='true' />}
    </button></AppTooltip>
  );
};
